import { Component } from "react"
import PropTypes from "prop-types"
import TransactionLogRow from "./transaction_log_row"

import styles from "../dynamic_applet.module.scss"

export default class TransactionLogTable extends Component {
  render() {
    return (
      <section>
        <div className={`${styles["dynamic_applet"]} ${styles.logs} partner-tools-body`}>
          <div className={`${styles["logs-table"]} health-logs`}>
            <header>
              <div className={`${styles["logs-column"]} ${styles["logs-column-header"]}`}>Time</div>
              <div className={`${styles["logs-column"]} ${styles["logs-column-header"]}`}>Request</div>
              <div className={`${styles["logs-column"]} ${styles["logs-column-header"]}`}>Task</div>
              <div className={`${styles["logs-column"]} ${styles["logs-column-header"]}`}>Result</div>
            </header>
            <div className="health-logs-content">
              {this.props.data.map((row, i) => (
                <TransactionLogRow transaction={row} key={i} />
              ))}
            </div>
          </div>
        </div>
      </section>
    )
  }
}

TransactionLogTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
}
